<template>
  <div>
    <div
      ref="modal"
      class="modal fade"
      :class="{ show: active, 'd-block': active }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Mass Edit </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              v-on:click="$emit('closeModal', null, null)"
              aria-label="btn-close"
            ></button>
          </div>
          <div class="modal-body">
                <div v-if="isLoading" class="d-flex align-items-center">
                <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                <strong>Loading...</strong>
              </div>
            <div class="row">
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Billable Tariff<span class="wajib">*</span>
                  </label>
                </div>
                <div class="col-lg-8">
                  <multiselect
                    @search-change="asyncBillableTariff"
                    v-model="billableTariff"
                    :options="fetchBillableTariff"
                    label="tariff_name"
                    :readonly="false"
                    track-by="tariff_name"
                    placeholder="Please Select"
                    @input="setAccessorial"
                  >
                    <span slot="noResult">-</span>
                  </multiselect>
                  <div
                    v-for="error in errors.customer_code"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Equipment Type<span class="wajib">*</span>
                  </label>
                </div>
                <div class="col-lg-8">
                  <v-select
                    :options="fetchEquipmentType"
                    v-model="equipmentType"
                    return-object
                  ></v-select>
                  <div
                    v-for="error in errors.equipment_type"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Min
                  </label>
                </div>
                <div class="col-lg-8">
                  <input
                    type="number"
                    name="Min"
                    id="Min"
                    v-model.number="forms.min"
                    class="form-control"
                  />
                  <div
                    v-for="error in errors.min"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Max
                  </label>
                </div>
                <div class="col-lg-8">
                  <input
                    type="number"
                    name="Max"
                    id="Max"
                    v-model.number="forms.max"
                    class="form-control"
                  />
                  <div
                    v-for="error in errors.max"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Sub Tariff<span class="wajib">*</span>
                  </label>
                </div>
                <div class="col-lg-8">
                  <v-select
                    :options="fetchSubTariff"
                    v-model="subTariff"
                    return-object
                  ></v-select>
                  <div
                    v-for="error in errors.sub_tariff"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Currency<span class="wajib">*</span>
                  </label>
                </div>
                <div class="col-lg-8">
                  <v-select
                    :options="fetchCurrency"
                    v-model="currency"
                    return-object
                  ></v-select>
                  <div
                    v-for="error in errors.sub_tariff"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >No Intermediate Stop
                  </label>
                </div>
                <div class="col-lg-8">
                  <div class="form-check mb-2">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="intermediateStop"
                      true-value="1"
                      false-value="0"
                      v-model="forms.no_intermediate_stops"
                    />
                    <label class="form-check-label" for="intermediateStop">
                      Yes
                    </label>
                  </div>
                  <div
                    v-for="error in errors.sub_tariff"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >All Inclusive
                  </label>
                </div>
                <div class="col-lg-8">
                  <div class="form-check mb-2">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="allInclusive"
                      true-value="1"
                      false-value="0"
                      v-model="forms.all_inclusive"
                    />
                    <label class="form-check-label" for="allInclusive">
                      Yes
                    </label>
                  </div>
                  <div
                    v-for="error in errors.sub_tariff"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Tier<span class="wajib">*</span>
                  </label>
                </div>
                <div class="col-lg-8">
                  <v-select
                    :options="fetchTier"
                    v-model="tier"
                    label="code"
                    return-object
                  ></v-select>
                  <div
                    v-for="error in errors.equipment_type"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Accessorial Application Rule<span class="wajib">*</span>
                  </label>
                </div>
                <div class="col-lg-8">
                  <input
                    type="text"
                    class="form-control"
                    v-model="forms.accessorial_application_rule"
                  />

                  <div
                    v-for="error in errors.equipment_type"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Allocation Method<span class="wajib">*</span>
                  </label>
                </div>
                <div class="col-lg-8">
                  <v-select
                    :options="fetchAllocationMethod"
                    v-model="allocationMethod"
                    label="code"
                    return-object
                  ></v-select>
                  <div
                    v-for="error in errors.equipment_type"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              v-on:click="$emit('closeModal')"
            >
              cancel
            </button>
            <div>
              <button
                type="button"
                class="btn btn-primary me-2"
                v-on:click="submitData"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import multiselect from "vue-multiselect";
export default {
  name: "modalSalesProjectMassEdit",
  emits: ["closeModal"],

  props: {
    showModal: Boolean,
    data: null,
  },
  components: {
    multiselect: multiselect,
  },
  watch: {
    showModal: {
      handler(newVal) {
        this.active = newVal;
        this.forms = {
           no_intermediate_stop:"0",
          all_inclusive:"0",
        };
        if (this.active) {
          this.loadBillableTariff();
        }
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      fetchEquipmentType: [],
      equipmentType: null,

      billableTariff: null,
      fetchBillableTariff: [],

      fetchCurrency: [],
      currency: null,

      fetchSubTariff: [],
      subTariff: null,

      fetchTier: [],
      tier: null,

      fetchAllocationMethod: [],
      allocationMethod: null,

      isLoading: false,
      opens: "center",
      active: this.showModal,
      company_code: "",
      fetchCompany: [],
      company: [],
      forms: {
         no_intermediate_stop:"0",
        all_inclusive:"0",
      },
      errors: [],
      locale: {
        format: "dd mmm yyyy H:MM:ss",
      },
    };
  },
  methods: {
    setAccessorial(ev) {
      this.forms.accessorial_application_rule = ev.tariff_name + "_ACC";
      console.log(ev);
    },
    loadEquipmentType() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=brmet`;
      this.fade(true);
      return this.$http.get(baseURI).then((response) => {
        this.fetchEquipmentType = response.data.datas;
        this.fade(false);
      });
    },
    loadSubTariff() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=brmstf`;
      this.fade(true);
      return this.$http.get(baseURI).then((response) => {
        this.fetchSubTariff = response.data.datas;
        this.fade(false);
      });
    },
    loadCurrency() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=brmcur`;
      this.fade(true);
      return this.$http.get(baseURI).then((response) => {
        this.fetchCurrency = response.data.datas;
        this.fade(false);
      });
    },
    loadAllocationMethod() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=brmam`;
      this.fade(true);
      return this.$http.get(baseURI).then((response) => {
        this.fetchAllocationMethod = response.data.datas;
        this.fade(false);
      });
    },
    loadTier() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=brmtier`;
      this.fade(true);
      return this.$http.get(baseURI).then((response) => {
        this.fetchTier = response.data.datas;
        this.fade(false);
      });
    },
    loadBillableTariff() {
      const baseURI =
        this.$settings.endPoint +
        `rm-billable-tariff?customer_code=${this.data?.header.customer_code}`;
      this.fade(true);
      return this.$http.get(baseURI).then((response) => {
        this.fetchBillableTariff = response.data.datas.data;
        this.fade(false);
      });
    },
    asyncBillableTariff(ev) {
      const baseURI =
        this.$settings.endPoint +
        `rm-billable-tariff?customer_code=${this.data?.header.customer_code}&tariff_name=${ev}`;
      this.fade(true);
      return this.$http.get(baseURI).then((response) => {
        this.fetchBillableTariff = response.data.datas.data;
        this.fade(false);
      });
    },
    submitData() {

      this.forms.sales_project_detail_ids = this.data.ids;
      this.forms.rm_billable_tariff_id = this.billableTariff?.rm_billable_tariff_id ? this.billableTariff.rm_billable_tariff_id : '' ;
      this.forms.billable_tariff_name = this.billableTariff?.tariff_name ? this.billableTariff.tariff_name : '';
      this.forms.tier = this.tier;
      this.forms.sub_tariff = this.subTariff;
      this.forms.currency = this.currency;
      this.forms.equipment_type = this.equipmentType;
      this.forms.allocation_method = this.allocationMethod;
      var baseURI =
        this.$settings.endPoint + "sales-project/mass-edit";
      return this.$http
        .patch(baseURI, this.forms)
        .then((response) => {
          if (response.data.status === 200) {
            this.$emit("closeModal");
            this.success2("Data Berhasil Disimpan");
            this.errors = [];
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push("/page-not-found");
            }
          }
          //this.resetForm();
        });
    },
    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },
    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success2(msg) {
      this.$swal({
        icon: "info",
        backdrop: true,
        title: "Information",
        html: "<p>* " + msg + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },
  },
  mounted() {
    this.loadEquipmentType();
    this.loadSubTariff();
    this.loadCurrency();
    this.loadTier();
    this.loadAllocationMethod();
  },
};
</script>
<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}
</style>
